import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {StocksService} from '../../core/services/gestion-stock/stocks.service';
import {UtilsService} from '../../core/utils/utils.service';
import {saveAs} from 'file-saver';
import {DxDataGridComponent} from 'devextreme-angular';
import {confirm} from 'devextreme/ui/dialog';
import {ButtonThemeEnum} from '../../shared/ui/button/button-theme-enum';
import {ResponseWrapper} from '../../core/suppliers/wrappers/response-wrapper';
import {ToastService} from '../../core/services/technique/toast.service';
import {MSG_KEY, MSG_SEVERITY} from '../../core/constants';

@Component({
  selector: 'yo-historique-inventaire',
  templateUrl: './historique-inventaire.component.html',
  styleUrls: ['./historique-inventaire.component.scss'],
  standalone: false
})
export class HistoriqueInventaireComponent implements OnInit, OnDestroy {

  @ViewChild('grid') grid: DxDataGridComponent;

  historiques: any[] = [];
  errors: {infosLine: string}[] = [];
  displayDeletePopupErrors = false;
  readonly ButtonThemeEnum = ButtonThemeEnum;

  private sub: Subscription;
  private subExport: Subscription;

  alimentaireLookup = [
    {value: null, text: 'Complet'},
    {value: true, text: 'Alimentaire'},
    {value: false, text: 'Non alimentaire'},
  ];

  constructor(private stockSvc: StocksService,
              public utils: UtilsService,
              private toastSvc: ToastService) {
  }

  ngOnInit(): void {
    this.loadHistoriques();
    this.subExport = this.stockSvc.triggerExportHistorique$.subscribe(() => this.exportSelected());
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.sub);
    this.utils.unsubscribe(this.subExport);
  }

  private loadHistoriques(): void {
    this.sub = this.stockSvc.getHistoriquesInventaire().subscribe(res => {
      this.historiques = res.resultList;
    });
  }

  getTypeAlimentaire(alimentaire: boolean | null): string {
    if (alimentaire === null || alimentaire === undefined) return 'Complet';
    return alimentaire ? 'Alimentaire' : 'Non alimentaire';
  }

  async exportSelected(): Promise<void> {
    const selected: any[] = await this.grid.instance.getSelectedRowsData();
    if (!selected || selected.length === 0) return;
    const ids: number[] = selected.map(row => row.id);
    this.stockSvc.exportHistoriqueInventaire(ids).subscribe(response => {
      const disposition = response.headers.get('Content-Disposition') ?? '';
      const match = disposition.match(/filename="([^"]+)"/);
      const filename = match ? match[1] : (ids.length === 1 ? 'inventaire.xlsx' : 'inventaires.zip');
      saveAs(response.body, filename);
    });
  }

  async deleteSelected(): Promise<void> {
    const selected: any[] = await this.grid.instance.getSelectedRowsData();
    if (!selected || selected.length === 0) return;

    const confirmed = await confirm(
      selected.length > 1
        ? `Êtes-vous sûr de vouloir supprimer les ${selected.length} historiques sélectionnés ?`
        : 'Êtes-vous sûr de vouloir supprimer cet historique ?',
      'Suppression'
    );
    if (!confirmed) return;

    const ids: number[] = selected.map(row => row.id);
    this.stockSvc.deleteHistoriqueInventaire(ids).subscribe(response => {
      const res = (response as ResponseWrapper<any>).one;
      const deletedCount = ids.length - (res?.messagesErrorList?.length ?? 0);
      if (deletedCount > 0) {
        this.loadHistoriques();
        this.grid.instance.clearSelection();
        const msg = deletedCount > 1
          ? `${deletedCount} historiques supprimés avec succès`
          : `L'historique a été supprimé avec succès`;
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, msg);
      }
      if (res?.messagesErrorList?.length) {
        this.errors = res.messagesErrorList.map((error: any) => ({infosLine: error.args || error.code}));
        this.displayDeletePopupErrors = true;
      }
    });
  }

  closeErrors(): void {
    this.errors = [];
    this.displayDeletePopupErrors = false;
  }
}